import { PublicInterceptor } from "../../../Base/interceptors/PublicInterceptor";
// OBTIENER LISTADO DE BANCOS
export const getCountriesList = async(Token) => {
    const result = await PublicInterceptor('Countries', 'GET', {}, Token)
    return result;
}
